/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Backstage_SearchInputs */

const en_scene_backstage_search = /** @type {(inputs: Scene_Backstage_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search or jump to…`)
};

/**
* | output |
* | --- |
* | "Search or jump to…" |
*
* @param {Scene_Backstage_SearchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_backstage_search = /** @type {((inputs?: Scene_Backstage_SearchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Backstage_SearchInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_backstage_search(inputs)
});